/* eslint-disable no-restricted-globals */

/* eslint-disable no-undef */

import React, { Suspense } from "react";
import Avatar from "@material-ui/core/Avatar";
import { connect } from "react-redux";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { userSignOut } from "actions/Auth";
import IntlMessages from "util/IntlMessages";
import Paper from "@material-ui/core/Paper";
import "../../admin/routes/setup/programme/table.css";
import { NotificationManager } from "react-notifications";
import { fetchJSON } from "helpers/axios";
import { IconButton } from "@material-ui/core";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";
import Toolbar from "@material-ui/core/Toolbar";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import { CircularProgress } from "@material-ui/core";
import ApplicantForm from "../ApplicantForm";

import GenericPdfDownloader from "./UserInfoDown";

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

function TabContainer({ children, dir }) {
  return (
    <div dir={dir} style={{ padding: 8 * 3 }}>
      {children}
    </div>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
  dir: PropTypes.string.isRequired,
};

// to determine which authUser to load
const UserType = (auth) => {
  let currentUrl = window.location.href;
  let url = currentUrl.split("/");
  if (url.includes("admin")) {
    return auth.adminUser;
  } else if (url.includes("student")) {
    return auth.studentUser;
  } else if (url.includes("applicant")) {
    return auth.applicantUser;
  }
};

class UserInfo extends React.Component {
  state = {
    anchorEl: null,
    open: false,
    passport: "",
    passportData: "data:image/jpeg;base64,",
    applicantDetails: [],
    // applicant: this.props.authUser,
    olevel: [],
    applicationFormDrawer: false,
    loadingOlevel: false,
  };

  toggleDrawer = (key, open) => async () => {
    this.setState({ [key]: open });

    // Load olevel only when opening application form
    if (
      key === "applicationFormDrawer" &&
      open === true &&
      this.props.userMode === "Applicant"
    ) {
      this.setState({ loadingOlevel: true });
      await this.applicantOlevel();
      await this.getUserDetails();
      this.setState({ loadingOlevel: false });
    }
  };
  handleClick = (event) => {
    this.setState({ open: true, anchorEl: event.currentTarget });
  };

  handleRequestClose = () => {
    this.setState({ open: false });
  };

  makeShiftLogOut = async () => {
    localStorage.removeItem("http://localhost:state");
    return setTimeout(() => {
      // location.href = "http://localhost:3000/portal/";
      location.href = "https://umcatc-portal-dev.azurewebsites.net/portal/";
      location.reload();
    }, 2000);
  };

  getPassport = () => {
    if (this.props.userMode === "Admin") {
      // console.log(this.props.userMode);

      if (this.props.user.Passport == null) {
        return this.props.user.LastName.charAt(0);
      }
    } else {
      if (this.props.user.Passport == null) {
        return (
          this.props?.user?.LastName?.charAt(0) +
          this.props?.user?.FirstName?.charAt(0)
        );
      }
    }
  };

  getUserDetails = async () => {
    try {
      const { token, ApplicantID } = this.props.authUser;
      this.setState({ loadingOlevel: true });
      const response = await fetchJSON(
        `api/Applicants/GetApplicantRecordById?ApplicantID=${ApplicantID}`,
        null,
        "GET",
        token
      );
      if (response.Status === "Ok") {
        this.setState({ loadingOlevel: false });
        this.setState({ applicantDetails: response.Data });
      } else {
        NotificationManager.error("Unable to complete operation.");
      }
    } catch (error) {
      NotificationManager.error("An error occurred.");
    }
  };

  showPassport = () => {
    if (this.props.userMode === "Admin") {
      return this.props.user.Passport;
    } else {
      if (this.props.userMode === "student") {
        return `${this.props.user.Passport}`;
        // return `data:image/jpg;base64, ${this.props.user.Passport}`;
      } else {
        return `${this.props.user.Passport}`;
        // return `data:image/jpg;base64, ${this.props.user.Passport}`;
      }
    }
  };

  async componentDidMount() {
    // try {
    //   const { userMode } = this.props;
    //   if (userMode == "Applicant") {
    //     // this.applicantOlevel();
    //   }
    // } catch (error) {
    //   NotificationManager.error("An error occurred.");
    //   console.log("e", error);
    // }
  }
  // This function is to get and set the applicant Olevel data
  applicantOlevel = async () => {
    try {
      const { token, ApplicantID } = this.props.authUser;
      const response = await fetchJSON(
        `api/OResults/NewhasOlevelResult?applicantId=${ApplicantID}`,
        null,
        "GET",
        token
      );
      if (response.Status === "Ok") {
        this.setState({
          olevel: response.Data,
        });
      } else {
        NotificationManager.warning(response.Message);
      }
    } catch (error) {
      NotificationManager.error("An error occurred.");
    }
  };

  render() {
    const { userMode, authUser } = this.props;
    const { applicationFormDrawer, olevel, applicantDetails } = this.state;
    return (
      <div
        className="user-profile d-flex flex-row align-items-center"
        style={{ margin: "-15px 20px" }}
      >
        {this.props.user.Passport === null ? (
          <Avatar className="bg-primary size-50 text-white">
            {this.getPassport()}
          </Avatar>
        ) : (
          <Avatar
            alt={this.getPassport()}
            src={this.showPassport()}
            className="user-avatar img-rounded"
          />
        )}

        <div
          className="user-detail"
          style={{ marginTop: "25px", marginLeft: "0px" }}
        >
          <h2 className="user-name" onClick={this.handleClick}>
            {`${this.props.user.LastName} ${this.props.user.FirstName}`}
            <i className="zmdi zmdi-caret-down zmdi-hc-fw align-middle" />
          </h2>
          <p>
            {/* {this.props.user.RoleName == undefined
              ? (userMode == "Staff"
                ? "Global Admin"
                : (userMode == "Student"
                ? "Student"
                : (authUser.AdmModeId === 1
                ? "Applicant - HND"
                : "Applicant - ND")))
              : this.props.user.RoleName} */}
          </p>
        </div>
        <Menu
          className="user-info"
          id="simple-menu"
          anchorEl={this.state.anchorEl}
          open={this.state.open}
          onClose={this.handleRequestClose}
          PaperProps={{
            style: {
              minWidth: 120,
              paddingTop: 0,
              paddingBottom: 0,
            },
          }}
        >
          {userMode == "Admin" &&
          this.props.authUser.UsernameEmail != "portal@sidmach.com" ? (
            <MenuItem
              onClick={() => {
                window.location.replace("/portal/admin/profile");
              }}
            >
              <i className="zmdi zmdi-account zmdi-hc-fw mr-2" />
              <IntlMessages id="popup.profile" />
            </MenuItem>
          ) 

          : userMode == "Student" ? (
            <MenuItem
              onClick={() => {
                window.location.replace("/portal/student/profile");
              }}
            >
              <i className="zmdi zmdi-account zmdi-hc-fw mr-2" />
              <IntlMessages id="popup.profile" />
            </MenuItem>
          ) : (
          <MenuItem
            onClick= {
              this.toggleDrawer("applicationFormDrawer", true) }
             
          >
            <i className="zmdi zmdi-sign-in zmdi-hc-fw mr-2" />
            <IntlMessages id="dashboard.applicationForm" />
          </MenuItem>
          )}

        

          {/* <MenuItem onClick={() => {
            this.handleRequestClose();
          }}>
            <Icon path={mdiLockReset}
                  title="Change Password"
                  size={.6}
            />
            <Link to="/app/changepassword" className="ml-2 text-dark"> Change Password</Link>
          </MenuItem> */}
          {/* <MenuItem onClick={this.handleRequestClose}>
            <i className="zmdi zmdi-settings zmdi-hc-fw mr-2"/>
            <IntlMessages id="popup.setting"/>
          </MenuItem> */}
         
          <MenuItem
            onClick={() => {
              this.handleRequestClose();
              this.props.userSignOut(this.props.user.sid, this.props.userMode);
              // this.makeShiftLogOut()
            }}
          >
            <i className="zmdi zmdi-sign-in zmdi-hc-fw mr-2" />

            <IntlMessages id="popup.logout" />
          </MenuItem>
        </Menu>

        {/*================= Application Form */}
        <Dialog
          fullScreen
          open={applicationFormDrawer}
          onClose={this.toggleDrawer("applicationFormDrawer", false)}
          TransitionComponent={Transition}
        >
          <AppBar
            className="position-relative"
            style={{ backgroundColor: "#1E90FF" }}
          >
            <Toolbar>
              <IconButton
                style={{ color: "white" }}
                onClick={this.toggleDrawer("applicationFormDrawer", false)}
                aria-label="Close"
              >
                <CloseIcon />
              </IconButton>
              <Typography
                variant="h5"
                style={{
                  flex: 1,
                  color: "white",
                }}
              >
                Applicant Details
              </Typography>
              <GenericPdfDownloader
                downloadFileName="ApplicantFormPDF"
                rootElementId="content"
              />
            </Toolbar>
          </AppBar>
          <ApplicantForm
            applicant={applicantDetails}
            olevel={olevel}
            loading={this.state.loadingOlevel}
          />
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = ({ settings, auth }) => {
  const { locale } = settings;
  const authUser = UserType(auth);
  return { locale, authUser };
};
export default connect(mapStateToProps, { userSignOut })(UserInfo);
